export const SET_SHOP_DETAILS = 'SET_SHOP_DETAILS';
export const TOGGLE_IMAGE_MODAL = 'TOGGLE_IMAGE_MODAL';
export const SET_SHOP_IMAGE_DATA = 'SET_SHOP_IMAGE_DATA';